import React from 'react';
import { MOBILE_BREAKPOINT } from '../../constants';
import { useResized } from '../../hooks/common';
import { AttributeTranslation } from '../../models';
import Flex, { FlexDirection, FlexJustification } from '../common/Flex';
import Jumbotron from '../common/Jumbotron';
import Tooltip from '../common/Tooltip';

export interface AttributeItemProps {
    attributeData: AttributeTranslation;
}

const AttributeItem = ({ attributeData }: AttributeItemProps) => {
    const mobileView = useResized(x => x <= MOBILE_BREAKPOINT);

    return (
        <div className='attribute-item'>
            <Jumbotron>
                <Flex direction={mobileView ? FlexDirection.Column : FlexDirection.Row} justification={FlexJustification.SpaceBetween}>
                    <div className='attribute-name'>{attributeData.name}</div>
                    <Tooltip id={`attribute_value_${attributeData.order}`} text={attributeData.value}>{attributeData.value}</Tooltip>
                </Flex>
            </Jumbotron>
        </div>
    );
};

export default AttributeItem;
